<script setup lang="ts">
import FormEvento from '../components/form-evento.vue'
import { useEventoStore } from '../store/useEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-evento',
    action: 'create',
    subject: 'evento',
  },
})

const { resetForm } = useEventoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormEvento />
</template>
